/**
 * FollowUp component 
 */

import {Button, Modal } from 'antd';
import DoctorNotesScreening from './doctor-notes-screen';
import React, {useState } from 'react';

// FollowUp component definition
export function FollowUp({...props }) {
    // State to control the visibility of the Modal
    let [visible, setVisible] = useState(false);
    return (
        <>
            {/* Button to open the follow-up modal */}
            <Button
                className={'edit-button'}
                size="small"
                type="link"
                onClick={() => {
                    setVisible(true); // Set Modal visibility to true
                }}
            >
                Follow up
            </Button>

            {/* Modal to display the follow-up form */}
            <Modal
                width={'100%'} // Set the width of the Modal
                header={null} // No header in the Modal
                destroyOnClose // Destroy modal content when closed
                visible={visible} // Control visibility using the `visible` state
                title="POST SCREENING FOLLOW UP" // Title of the Modal
                footer={null} // No footer buttons
                onCancel={() => setVisible(false)} // Close the modal on cancel
                callback={() => {
                    setVisible(false)
                }}
            >
                {/* DoctorNotesScreening component inside the Modal */}
                <DoctorNotesScreening
                    doctorNote={true} // Pass `doctorNote` prop as true
                    readOnlyMode={true} // Make the DoctorNotesScreening read-only
                    test_code={props.TestCode} // Pass the test code from props
                    {...props} // Spread other props
                />
            </Modal>
        </>
    );
}
